import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import {
  IsOfflineContextProvider,
  AuthContextProvider,
} from '@oneblink/apps-react'
import AppConfigProvider from 'Providers/AppConfigProvider'
import SystemMaintenanceProvider from 'Providers/SystemMaintenanceProvider'

ReactDOM.render(
  <React.StrictMode>
    <SystemMaintenanceProvider>
      <AppConfigProvider>
        <IsOfflineContextProvider>
          <AuthContextProvider>
            <App />
          </AuthContextProvider>
        </IsOfflineContextProvider>
      </AppConfigProvider>
    </SystemMaintenanceProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
